@import 'styles/variables';
@import 'styles/mixins';

.features {
  flex-grow: 1;
}

.featureDetails {
  @include sm-regular;

  color: var(--light-neutral-50, #4c566a);
  display: flex;
  gap: 8px;
  margin-bottom: 8px;

  .featureText {
    margin-bottom: 0;
  }
}
